/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import {Logs} from "../../APIClient.jsx";
import Console from "../Console.jsx";

class NodeLogs extends React.Component {
    constructor() {
        super();

        this.state = {
            logs: [],
            error: null
        }
    }

    async fetchData() {
        let {nodeId} = this.props

        let logs = await Logs.getNodeLogs(nodeId, "edgeClient")
        if (logs.error) {
            this.setState({error: "Failed to fetch logs. Displaying cached logs."})
            return
        }
        let messages = (logs?.logs ?? [])
        this.setState({logs: messages, error: null})

    }

    componentDidMount() {
        this.fetchData()

        this.interval = setInterval(() => {
            this.fetchData()

        }, 10000)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.nodeId !== this.props.nodeId) {
            this.fetchData()
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    render() {
        let {logs, error} = this.state
        return (
            <div>

                <Console logs={logs} titel={"Node logs"} error={error}/>

            </div>
        );
    }
}

NodeLogs.propTypes = {};

NodeLogs.defaultProps = {};


export default NodeLogs;
